/**
 * The session-once truncation warning.
 *
 * Any list response that says it left rows behind lands here (fired from the axios
 * response interceptor), so a partial list warns even on a page that has not yet been
 * converted to the shared list hook. His choice, 17 Aug 2026: a bar on the page AND a
 * toast the first time it happens in a session — the toast for the surprise, the bar
 * so it is still on screen a minute later.
 */
import { toast } from 'sonner';
import { truncationSentence } from './listMeta';

export const LIST_TRUNCATED_EVENT = 'list-truncated';

// One toast per endpoint per session: a page that polls must not nag.
const warned = new Set();

function endpointKey(url = '') {
  return String(url).split('?')[0];
}

export function reportTruncatedList(url, meta) {
  const key = endpointKey(url);
  window.dispatchEvent(
    new CustomEvent(LIST_TRUNCATED_EVENT, { detail: { endpoint: key, meta } })
  );
  if (warned.has(key)) return;
  warned.add(key);
  const sentence = truncationSentence(meta, 'records');
  if (!sentence) return;
  toast.warning(`${sentence}. Narrow your filters to see the rest.`, {
    duration: 8000,
    id: `truncated-${key}`,
  });
}

/** Test/QA hook — forget what has already been warned about. */
export function resetTruncationWarnings() {
  warned.clear();
}
